module.exports = __webpack_public_path__ + "img/education.a53a323d.svg";